module.exports = __webpack_public_path__ + "static/vampire_spawn-ad61ed8df295137c57f60d924f25648b.jpg";